import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextInput, FileInput, SelectInput, DatetimeInput, BooleanInput, NumberInput, DisabledInput } from 'components/input';
import { ImageField, FileField, TextField } from 'components/field';
import { SimpleFormNoInit } from 'components/form';
import { Edit } from 'components/detail';
import * as urls from './urls';
import { maxLength } from "components/form/validate";
import * as utils from "./utils";


function DownloadLink({ record = {} }) {
  if (!record.shop_id_list_file_url) return null;
  const content = <a target="_blank" rel="noopener noreferrer" href={record.shop_id_list_file_url}>shop_id.csv</a>;
  return <TextField source="content" record={{ content }} label="Shop Ids File" />
}

class DualScreenAdEditBase extends Component {
  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();
    const properties = ['ad_type', 'ad_name', 'target_type', 'priority'];
    properties.forEach((property) => {
      formDataRecord.append(property, record[property]);
    });
    record['shop_id_list_file'] && formDataRecord.append('shop_id_list_file', record['shop_id_list_file']);
    formDataRecord.append('ad_status', record['ad_status'] ? utils.DualScreenAdStatusEnable : utils.DualScreenAdStatusDisable);
    // eslint-disable-next-line
    formDataRecord.append('valid_from', record['valid_from'].replace(/(\d+-\d+-\d+\s\d+\:\d+)(\:\d+)?/, '$1:00'));
    // eslint-disable-next-line
    formDataRecord.append('valid_to', record['valid_to'].replace(/(\d+-\d+-\d+\s\d+\:\d+)(\:\d+)?/, '$1:59'));
    record['image'] && formDataRecord.append('image', record['image']);
    props.crudUpdate(props.resource, props.id, formDataRecord, props.data, props.editBackendPath, basePath);
  };

  render() {
    const { formValues, formInitial } = this.props;
    const published = ['Publish', 'Expired'].includes(formInitial.publish_status);

    return (
      <Edit
        editBackendPath={urls.dualScreenAdEditBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleFormNoInit>

          <SelectInput
            disabled={published}
            source='ad_type'
            label='Ad Type'
            choices={utils.DualScreenAdTypeChoices}
            isRequired={true}
          />

          {
            published ? (
              <DisabledInput
                source='ad_name'
                label='Name'
              />
            ) : <TextInput
                disabled={published}
                source='ad_name'
                label='Name'
                validators={[maxLength(255)]}
              />
          }

          <SelectInput
            disabled={published}
            source='target_type'
            label='Target Users'
            choices={utils.DualScreenAdTargetUsersChoices}
            defaultValue={utils.DualScreenAdTargetTypeAll}
            isRequired={true}
          />

          {
            formValues.target_type === utils.DualScreenAdTargetTypeSelect && !published && (
              <FileInput
                accept=".csv"
                source="shop_id_list_file"
                label="Shop Ids file"
              >
                <FileField source="src" title="title" />
              </FileInput>
            )
          }
          {
            !formValues.shop_id_list_file && formValues.target_type === utils.DualScreenAdTargetTypeSelect ? (
              <DownloadLink source="shop_id_list_file" label="Shop Ids File" />) : null
          }


          {
            published ? (
              <DisabledInput
                source='priority'
                label='Priority'
              />
            ) : <NumberInput
                disabled={published}
                source='priority'
                label='Priority'
                isRequired={true}
              />
          }

          {
            published ? (
              <DisabledInput
                source='valid_from'
                label='Valid From'
              />
            ) : <DatetimeInput
                disabled={published}
                source='valid_from'
                label='Valid From'
                isRequired={true}
                optionsTime={{}}
              />
          }

          {
            published ? (
              <DisabledInput
                source='valid_to'
                label='Valid To'
              />
            ) : <DatetimeInput
                disabled={published}
                source='valid_to'
                label='Valid To'
                isRequired={true}
                optionsTime={{}}
              />
          }


          {published ? null : (
            <FileInput
              disabled={published}
              accept="image/jpeg,image/jpg,image/png"
              source='image'
              label='Image'
              placeholder={<p>Select or drop your file here</p>}
            >
              <ImageField source="src" title="title" />
            </FileInput>
          )
          }

          {!formValues.image && <ImageField source="image_url" title="title" />}


          <BooleanInput source='ad_status' label="Status" isRequired={true} />

        </SimpleFormNoInit>
      </Edit>
    )
  }
}

const DualScreenAdEdit = connect(
  (state) => {
    return {
      formValues: ((state.form['record-form'] || {}).values || {}),
      formInitial: ((state.form['record-form'] || {}).initial || {}),
    }
  },
  {},
)(DualScreenAdEditBase);

export default DualScreenAdEdit



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/DualScreenAdEdit.js